import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateProjectStats } from 'redux/realEstateSlice';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonDelete from 'utils/buttons/ButtonDelete';

const DeleteModal = ({ project, setShow, handleStatus }) => {
  const handleClose = () => setShow(false);

  const { realEstate } = useSelector(state => state.realEstate);
  const dispatch = useDispatch();

  const handleDelete = async prop => {
    await handleStatus(prop);
    dispatch(getRealEstateProjectStats(realEstate.id));
    handleClose();
  };

  return (
    <Modal
      keyboard={true}
      show={true}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <FontAwesomeIcon
          icon="fa-trash-can"
          title="Eliminar"
          size="1x"
          style={{ marginRight: 8, color: '#e63757' }}
        />
        <Modal.Title>Eliminar propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          El emprendimiento de dirección{' '}
          <b>
            {project.location.street} {project.location.number}
          </b>{' '}
          se eliminará, lo que lo marcará como operación no concretada y los
          clientes no podrán verlo.
          <br />
          <br />
          ¿Está seguro de confirmar esta acción?
        </div>

        <ModalButtonsContainer>
          <ButtonClose
            text="Cancelar"
            funcion={handleClose}
            variant="secondary"
          />

          <ButtonDelete
            text="Eliminar"
            funcion={handleDelete}
            data={{ id: project._id, status: 'deleted' }}
          />
        </ModalButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

DeleteModal.propTypes = {
  project: PropTypes.object.isRequired,
  setShow: PropTypes.func.isRequired,
  handleStatus: PropTypes.func.isRequired
};

export default DeleteModal;
